import { render, staticRenderFns } from "./team-result.vue?vue&type=template&id=481694c8&scoped=true&"
import script from "./team-result.vue?vue&type=script&lang=js&"
export * from "./team-result.vue?vue&type=script&lang=js&"
import style0 from "./team-result.vue?vue&type=style&index=0&id=481694c8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481694c8",
  null
  
)

export default component.exports